import { render, staticRenderFns } from "./ExtensionsModules.vue?vue&type=template&id=2524d967&scoped=true"
import script from "./ExtensionsModules.vue?vue&type=script&lang=js"
export * from "./ExtensionsModules.vue?vue&type=script&lang=js"
import style0 from "./ExtensionsModules.vue?vue&type=style&index=0&id=2524d967&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2524d967",
  null
  
)

export default component.exports